import * as consts from '../constants';
import * as commonActions from './commonActions';

import warrantyApi from '../api/warrantyApi';

export function loadWarrantiesSuccess(pagingModel) {
    return { type: consts.ACTONS.LOAD_WARRANTIES_SUCCESS, pagingModel };
}

export function loadWarrantiesFailed() {
    return { type: consts.ACTONS.LOAD_WARRANTIES_FAILED };
}

export function loadWarranties(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return warrantyApi.loadWarranties(getState().authenticationState.token, pagingModel).then(res => {
            res.sortName = pagingModel.sortName;
            res.sortOrder = pagingModel.sortOrder;
            res.companyName = pagingModel.companyName;
            res.warrantyName = pagingModel.warrantyName;

            dispatch(commonActions.unlockScreen());
            dispatch(loadWarrantiesSuccess(res));
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadWarrantiesFailed());
            throw (error);
        });
    };
}

export function loadAllWarranties() {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return warrantyApi.loadAllWarranties(getState().authenticationState.token).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadWarranty(id) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return warrantyApi.loadWarranty(getState().authenticationState.token, id).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveWarranty(warranty) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return warrantyApi.saveWarranty(getState().authenticationState.token, warranty).then(savedWarranty => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadWarranties(getState().warrantyState));
            return savedWarranty;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function deleteWarranty(warrantyId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return warrantyApi.deleteWarranty(getState().authenticationState.token, warrantyId).then(() => {
            dispatch(loadWarranties(getState().warrantyState));
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function cloneWarranty(warrantyId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return warrantyApi.cloneWarranty(getState().authenticationState.token, warrantyId).then((clonedWarrantyId) => {
            dispatch(commonActions.unlockScreen());
            return clonedWarrantyId;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}
